import React from 'react'
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import CloudKitchen from '@/components/outlet/CloudKitchen';

const cloudKitchen = () => {
  return (
    <>
      <Head>
        <title>Cloud Kitchen POS Management with Inventory Management</title>
        <link rel="canonical" href="https://queuebuster.co/outlet/cloud-kitchen" />
        <link rel="alternate" href="https://queuebuster.co/outlet/cloud-kitchen" hrefLang="en-us" />
        <meta name="description" content="QueueBuster Cloud Kitchen POS enhances efficiency by managing orders, inventory, and operations. Perfect for single kitchens or multi-brand setups, boosting productivity and growth." />
        <meta property="og:title" content="QueueBuster Cloud Kitchen POS: Efficient Order, Inventory & Workflow Management" />
        <meta property="og:description" content="QueueBuster Cloud Kitchen POS simplifies operations for single kitchens or multi-brand setups. Manage orders, streamline inventory, and enhance productivity with a robust solution tailored for speed, precision, and adaptability in the cloud kitchen industry." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/payment-og%2B(1)+(1).jpg" />
        <meta property="og:url" content="https://queuebuster.co/outlet/cloud-kitchen" />
      </Head>
         <SchemaTags page="cloud-kitchen" />
      <CloudKitchen />
    </>
  )
}

export default cloudKitchen